import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const entityListSlice = createSlice({
  name: "entityList",
  initialState: [],
  reducers: {
    setEntityList: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const statusPortalDataSlice = createSlice({
  name: "statusPortalData",
  initialState: [],
  reducers: {
    setPortalStatusData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const portalDataSlice = createSlice({
  name: "portalData",
  initialState: {},
  reducers: {
    setPortalData: (_state: any, action: PayloadAction<any>) => (action.payload ? action.payload : {}),
    mergePortalData: (state: any, action: PayloadAction<any>) =>
      action.payload ? { ...state, ...action.payload } : {},
  },
});

const profileDataSlice = createSlice({
  name: "profileData",
  initialState: [],
  reducers: {
    setPortalProfiles: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const portalEntityListSlice = createSlice({
  name: "portalEntityList",
  initialState: [],
  reducers: {
    setPortalEntityList: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const portalSettingSlice = createSlice({
  name: "portalSetting",
  initialState: [],
  reducers: {
    getPortalSetting: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const customModulesSlice = createSlice({
  name: "customModules",
  initialState: [],
  reducers: {
    setCustomModules: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const categoryListSlice = createSlice({
  name: "categoryList",
  initialState: [],
  reducers: {
    setCategoryList: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const portalCategoryListSlice = createSlice({
  name: "portalCategoryList",
  initialState: [],
  reducers: {
    setPortalCategoryList: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const userInPortalSlice = createSlice({
  name: "UserInPortal",
  initialState: [],
  reducers: {
    getPortalUserList: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const userCountInPortalSlice = createSlice({
  name: "UserCountInPortal",
  initialState: "",
  reducers: {
    getPortalUserCount: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const currentUserPermissionsSlice = createSlice({
  name: "currentUserPermissions",
  initialState: [],
  reducers: {
    setPortalUserPermission: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const dsrDataSlice = createSlice({
  name: "dsrData",
  initialState: [],
  reducers: {
    getDsrData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const symbolsDataSlice = createSlice({
  name: "symbolsData",
  initialState: [],
  reducers: {
    getSymbolsData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const renderHeaderSlice = createSlice({
  name: "renderHeader",
  initialState: false,
  reducers: {
    setRenderHeader: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setEntityList: setEntityListAction } = entityListSlice.actions;
export const { setPortalStatusData: setPortalStatusDataAction } = statusPortalDataSlice.actions;
export const { setPortalData: setPortalDataAction, mergePortalData: mergePortalDataAction } = portalDataSlice.actions;
export const { setPortalProfiles: setPortalProfilesAction } = profileDataSlice.actions;
export const { setPortalEntityList: setPortalEntityListAction } = portalEntityListSlice.actions;
export const { getPortalSetting: getPortalSettingAction } = portalSettingSlice.actions;
export const { setCustomModules: setCustomModulesAction } = customModulesSlice.actions;
export const { setCategoryList: setCategoryListAction } = categoryListSlice.actions;
export const { setPortalCategoryList: setPortalCategoryListAction } = portalCategoryListSlice.actions;
export const { getPortalUserList: getPortalUserListAction } = userInPortalSlice.actions;
export const { getPortalUserCount: getPortalUserCountAction } = userCountInPortalSlice.actions;
export const { setPortalUserPermission: setPortalUserPermissionAction } = currentUserPermissionsSlice.actions;
export const { getDsrData: getDsrDataAction } = dsrDataSlice.actions;
export const { getSymbolsData: getSymbolsDataAction } = symbolsDataSlice.actions;
export const { setRenderHeader } = renderHeaderSlice.actions;

export const setEntityList = entityListSlice.reducer;
export const statusPortalData = statusPortalDataSlice.reducer;
export const portalData = portalDataSlice.reducer;
export const profileData = profileDataSlice.reducer;
export const portalEntityList = portalEntityListSlice.reducer;
export const getPortalSetting = portalSettingSlice.reducer;
export const customModules = customModulesSlice.reducer;
export const setCategoryList = categoryListSlice.reducer;
export const setPortalCategoryList = portalCategoryListSlice.reducer;
export const UserInPortal = userInPortalSlice.reducer;
export const UserCountInPortal = userCountInPortalSlice.reducer;
export const currentUserPermissions = currentUserPermissionsSlice.reducer;
export const getDsrData = dsrDataSlice.reducer;
export const getSymbolsData = symbolsDataSlice.reducer;
export const renderHeader = renderHeaderSlice.reducer;
